import service from '../../../api/dedicatedPreorderService'
import { PreorderListItem } from '../../../api/dedicatedPreorderTypes'

export const isPreorderHistory = (item: PreorderListItem) => item.status === 'released' || item.status === 'cancelled'

// The API has no status filter. Read every page before separating active orders
// from history, so older active orders are not hidden behind newer finished ones.
export async function loadPreorders(isCurrent: () => boolean): Promise<PreorderListItem[] | undefined> {
  const items = new Map<string, PreorderListItem>()
  let page = 1
  while (isCurrent()) {
    const { data } = await service.getList({ page, page_size: 100, ordering: '-created_at' })
    if (!isCurrent()) return undefined
    const previousSize = items.size
    data.objects.forEach(item => items.set(item.id, item))
    if (!data.next && items.size >= data.count) return [...items.values()]
    if (items.size === previousSize) throw new Error('Incomplete preorder catalog')
    page++
  }
  return undefined
}

export function selectPreorders(items: PreorderListItem[], search: string, ordering: string) {
  const needle = search.trim().toLocaleLowerCase()
  const descending = ordering.startsWith('-')
  const field = descending ? ordering.slice(1) : ordering
  const value = (item: PreorderListItem) => field === 'name' ? item.name || item.hostname : field === 'status' ? item.status : item.created_at
  return items.filter(item => !needle || `${item.name} ${item.hostname} ${item.hardware.cpu.model}`.toLocaleLowerCase().includes(needle))
    .sort((a, b) => (descending ? -1 : 1) * value(a).localeCompare(value(b)))
}
